import MobileFilter from 'components/MobileFilter';
import { useFiltersStore } from 'store/useFiltersStore';
import usePropertiesStore from 'store/usePropertiesStore';
import { DEFAULT_FILTER } from 'util/Constants';
import { getFilterCount } from 'util/Funcs';
import { useState } from 'react';

const PublicMobileFilterSection = () => {
    const { totalPropertiesCount } = usePropertiesStore();
    const { currentFilter, setCurrentFilter } = useFiltersStore();
    const [isFilterVisible, setIsFilterVisible] = useState(false);

    const onClearClicked = () => {
        setCurrentFilter(DEFAULT_FILTER);
    };

    return (
        <>
            <div
                className="rounded-[5px] h-[42px] border border-my-blue w-full px-[12px] text-my-blue flex justify-between items-center cursor-pointer"
                onClick={() => setIsFilterVisible(true)}
            >
                <span>{`Filter (${getFilterCount(currentFilter)})`}</span>
                <div className="w-5 h-5">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z" fill="currentColor" />
                    </svg>
                </div>
            </div>

            <MobileFilter
                prevFilter={currentFilter}
                onChange={setCurrentFilter}
                resultCount={totalPropertiesCount}
                visible={isFilterVisible}
                onClose={() => setIsFilterVisible(false)}
                showAvailabilityFilter={false}
                isLoggedIn={false}
            />

            <div className="flex gap-[10px] w-max pt-[10px] text-[12px]">
                {getFilterCount(currentFilter) > 0 && (
                    <div className="flex items-center gap-[5px] cursor-pointer text-my-red" onClick={onClearClicked}>
                        <div className={`rounded-full w-[20px] h-[20px] flex justify-center items-center cursor-pointer border border-my-red`}>
                            <div className="leading-[25px] text-[25px]">{'×'}</div>
                        </div>
                        <div>{'Clear'}</div>
                    </div>
                )}
            </div>
        </>
    );
};

export default PublicMobileFilterSection;
